import Services from '../services';

export default {
  name: 'transfer',
  mixins: [Services],
  data() {
    return {
      statusses: [
        {
          name: 'All',
          value: ''
        },
        {
          name: 'In transit',
          value: 'in_transit'
        },
        {
          name: 'Transferred',
          value: 'transferred'
        }
      ],
      status: {
        name: 'All',
        value: ''
      },
      sourse_store: {},
      destination_store: {},
      transfer_edit_index: -1,
      transfers: [],
      transfer: {
        items: []
      },
      transfers_page: 1,
      transfers_total: 0,
      data_loading: false
    }
  },
  methods: {
    async update_transfers() {
      this.data_loading = true
      var transfers = this.$communicator.then(this, await this.$communicator('transfers', {
        arguments: [10, this.transfers_page],
        params: {
          status: this.status.value,
          first_service: this.sourse_store._id,
          second_service: this.destination_store._id,
          search: this.search
        }
      }))
      if (transfers) {
        for (let i = 0; i < transfers.data.length; i++) {
          transfers.data[i].status = this.$t(transfers.data[i].status)
          var time = new Date(transfers.data[i].date)
          transfers.data[i].date = time.getDate() + '/' + (time.getMonth() + 1) + '/' + time.getFullYear();
        }
        this.transfers = transfers.data
        this.transfers_total = transfers.page
      }
      this.data_loading = false
    }
  },
  mounted() {
    this.statusses = [
      {
        name: this.$t('all'),
        value: ''
      },
      {
        name: this.$t('in_transit'),
        value: 'in_transit'
      },
      {
        name: this.$t('transferred'),
        value: 'transferred'
      }
    ]
    this.status = {
      name: this.$t('all'),
      value: ''
    }
    this.update_transfers()
  }
}